import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDataSource } from '@/src/renderer/lib/dataSource'
import { onChildRecurrenceDropped } from '@/src/renderer/lib/recurrence'
import { showUndoToast } from '@/src/renderer/components/common/UndoToast'
import { RecurringIcon } from '@/src/renderer/components/icons/RecurringIcon'

/**
 * **Die Meldung, wenn Unteraufgaben ihren Rhythmus verlieren** (#205, Punkt 5): Eine Aufgabe ist
 * gerade wiederkehrend geworden, und ihre Unteraufgaben wiederholten sich selbst. Die Datenquelle
 * hat ihnen die Wiederholung schon abgenommen; hier steht, dass es passiert ist — mit einem Weg
 * zurück (Knopf und `⌘Z`): Die Unteraufgaben bekommen ihren Rhythmus wieder, die Aufgabe ihre
 * vorige Wiederholung.
 *
 * Einmal je Hauptfenster (`MainLayout`), wie der Geschafft-Moment.
 */
export function useChildRecurrenceNotice(): void {
  const { t } = useTranslation()
  const source = useDataSource()

  useEffect(() => onChildRecurrenceDropped(({ parentId, parentBefore, children }) => {
    showUndoToast({
      message: t('recurrence.childrenDropped', { count: children.length }),
      undoLabel: t('common.undo'),
      undoneMessage: t('undo.restored.childRecurrence', { count: children.length }),
      icon: <RecurringIcon size={18} />,
      tone: 'recurring',
      onUndo: async () => {
        await source.updateTasks([
          { id: parentId, changes: { recurrence: parentBefore } },
          ...children.map(child => ({ id: child.id, changes: { recurrence: child.recurrence } })),
        ])
      },
    })
  }), [t, source])
}
